import { useOrganizationStore } from '@/stores/organizationStore';

/**
 * Hook that provides currency-related functionality
 * Now reads currency from organization store instead of separate currency store
 */
export const useCurrency = () => {
  const {
    getCurrentCurrency,
    formatAmount,
    getCurrencySymbol,
  } = useOrganizationStore();

  return {
    currentCurrency: getCurrentCurrency(),
    setCurrency: () => {
      // This is now handled through updateOrganization
      console.warn('setCurrency is deprecated. Use updateOrganization({ currency: newCurrency }) instead.');
    },
    formatAmount,
    currencySymbol: getCurrencySymbol(),
  };
};
